import { getUserInfo } from '@/utils/auth';

const d = (el, binding) => {
  const { permissions } = getUserInfo();
  if (permissions && permissions.indexOf(binding.value) === -1) {
    el.remove();
  }
};

export default {
  bind: d,
  inserted: d,
  update: d
};



// WEBPACK FOOTER //
// ./src/directives/action.js